import type { Category } from 'src/types';

const WHITE_LIST = [
  '1944', // Shoes, fashion and accessories
];

export const isWhitelistedForSizes = (category?: Category | null) => {
  return Boolean(
    category?.path?.length &&
      category?.path?.some(categoryPath => WHITE_LIST.includes(categoryPath.id))
  );
};
